import {
  Avatar,
  Box,
  Chip,
  Grid,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat, formatDNI, textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { ActionsListWidget, LoadingWidget } from '../../../../widgets';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { PARAMS_ENTIDADES } from '../../../entidad/entidades/EntidadesReducer';
import { NameComponent } from '../../usuarios/components/ListadoUsuarios';
import {
  allUsuEntidadesAction,
  deleteUsuEntidadesAction,
  setActivoUsuEntidadesAction,
} from '../UsuEntidadesAction';
import {
  PARAMS_USU_ENTIDADES,
  SELECTS_USU_ENTIDADES,
} from '../UsuEntidadesReducer';
import ExpandeUsuEntidades from './ExpandeUsuEntidades';

const ListadoUsuEntidades = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  const [rows, setRows] = React.useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  let intervalSearch = null;

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteUsuEntidadesAction(
      { dispatch, notify },
      usuEntidadesStore.activo.id,
      {
        idEntidad: entidadesStore.activo.id,
        ...usuEntidadesStore.params,
      },
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  React.useEffect(() => {
    const payload = {
      idEntidad: entidadesStore.activo.id,
      ...usuEntidadesStore.params,
    };
    dispatch({ type: PARAMS_ENTIDADES, payload });
    const fetchData = async () => {
      await allUsuEntidadesAction(dispatch, payload);
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuEntidadesStore.params]);

  React.useEffect(() => {
    const fetchData = () => {
      const rowsData = [];
      const lista = usuEntidadesStore.all.filter(
        (el) => el.usuario.id !== loginStore.user.id,
      );

      lista.forEach((el) => {
        const nombreCompleto = `${el.usuario.perfil.papellido} ${
          el.usuario.perfil.sapellido ?? ''
        } ${el.usuario.perfil.pnombre} ${el.usuario.perfil.snombre ?? ''}`;
        rowsData.push({
          id: el.id,
          foto: el.usuario.perfil,
          fechaNacimiento: dateformat(el.usuario.perfil.fechaNacimiento, {
            inverse: true,
          }),
          genero: el.usuario.perfil.genero,
          correo: el.usuario.correo,
          dni: `${el.usuario.perfil.tipoDni}-${formatDNI(
            el.usuario.perfil.dni,
          )}`,
          nombre: {
            nombre: nombreCompleto,
            correo: el.usuario.correo,
          },
          perfil: el.isInvitado
            ? `${el.perfiles?.[0]?.perfil.nombre ?? ''} - INVITADO`
            : el.perfiles.length > 0
            ? el.perfiles
            : 'Sin Asignar',
          estatus:
            el.usuario.estatus?.id !== 1
              ? el.usuario?.estatus?.nombre
              : el.estatus?.nombre,
          actions: el,
        });
      });
      setRows(rowsData);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuEntidadesStore.all]);

  const _handleEditClick = async (id) => {
    const data = usuEntidadesStore.all.find((el) => el.id === id);
    await setActivoUsuEntidadesAction(dispatch, data);
    history.push(ROUTES.panelUsuEntidades.to);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.foto.name,
      label: CONST.foto.label,
      width: '10%',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value.pnombre}
              sx={{ width: 45, height: 45, mr: 1 }}
              src={getFilesArchivos(value.avatar)}
            />
          );
        },
      },
    },
    {
      name: CONST.dni.name,
      label: CONST.dni.label,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ minWidth: '8em' }}>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value}
              </NameComponent>
            </Box>
          );
        },
      },
    },
    // {
    //   name: CONST.dniEscolar.name,
    //   label: CONST.dniEscolar.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Tooltip
    //           describeChild
    //           title={CONST.dniEscolar.family}
    //           placement="left"
    //         >
    //           <Chip
    //             label={value}
    //             size="small"
    //             color={value === "Si" ? "warning" : "default"}
    //           />
    //         </Tooltip>
    //       );
    //     },
    //   },
    // },
    {
      name: CONST.nombre.name,
      label: 'Nombres y apellidos',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
              <CopyToClipboard
                text={value.correo}
                onCopy={() => {
                  notify(`${value.correo} Copiado!`, {
                    vertical: 'bottom',
                  });
                }}
              >
                <Typography
                  variant="body1"
                  color="initial"
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginRight: '10px',
                    cursor: 'pointer',
                    '&:hover': {
                      color: blue[700],
                    },
                  }}
                >
                  {value.correo}
                </Typography>
              </CopyToClipboard>
            </>
          );
        },
      },
    },
    {
      name: CONST.genero.name,
      label: CONST.genero.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: CONST.fechaNacimiento.name,
    //   label: CONST.fechaNacimiento.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },
    {
      name: CONST.perfil.name,
      label: CONST.perfil.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return typeof value === 'string'
            ? value
            : value.map((el) => el.perfil.nombre).join(', ');
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={
                  value === 'ACTIVO'
                    ? 'success'
                    : value === 'BLOQUEADO'
                    ? 'error'
                    : 'warning'
                }
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <BotonComponent
                click={async () => {
                  await setActivoUsuEntidadesAction(dispatch, value);
                  history.push(ROUTES.panelUsuEntidades.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de gestión"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onDelete={async () => {
                  const data = usuEntidadesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoUsuEntidadesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  const data = usuEntidadesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  window.open(data.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: usuEntidadesStore.params.limit,
    count: usuEntidadesStore.pagination.totalItems,
    page: usuEntidadesStore.pagination.currentPage - 1,
    rowsPerPageOptions: [25, 50, 100, 150, 250, 500, 700, 1000],
    print: false,
    download: false,
    textLabels,
    expandableRows: true,
    serverSide: true,
    rowSelectionModel: rowSelectionModel,
    onClearSelection: () => {
      setRowSelectionModel([]);
      dispatch({ type: SELECTS_USU_ENTIDADES, payload: [] });
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      setRowSelectionModel(allRowsSelected);
      const selectedUsers = allRowsSelected.map(
        (row) => usuEntidadesStore.all[row.index],
      );
      dispatch({ type: SELECTS_USU_ENTIDADES, payload: selectedUsers });
    },
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(() => {
          const payload = {
            ...usuEntidadesStore.params,
            q: searchQuery,
          };
          dispatch({
            type: PARAMS_USU_ENTIDADES,
            payload,
          });
        }, 800);
      }
    },
    onSearchClose: () => {
      const payload = {
        ...usuEntidadesStore.params,
        q: null,
        page: 1,
      };
      dispatch({
        type: PARAMS_USU_ENTIDADES,
        payload,
      });
    },
    onChangePage: async (currentPage) => {
      const payload = {
        ...usuEntidadesStore.params,
        page: currentPage + 1,
      };
      dispatch({
        type: PARAMS_USU_ENTIDADES,
        payload,
      });
    },
    onChangeRowsPerPage: async (numberOfRows) => {
      const payload = {
        ...usuEntidadesStore.params,
        limit: numberOfRows,
        page: 1,
      };
      dispatch({
        type: PARAMS_USU_ENTIDADES,
        payload,
      });
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const data = usuEntidadesStore.all.find(({ id }) => id === rowData[0]);
      return (
        <TableRow>
          <TableCell colSpan={rowData.length}>
            <ExpandeUsuEntidades data={data} />
          </TableCell>
        </TableRow>
      );
    },
    customSearch: (q, currentRow, columns) => {
      q = q.toLowerCase();
      const data = usuEntidadesStore.all.find(({ id }) => id === currentRow[0]);
      if (!data) return true;
      const userData = `${data.usuario.perfil.dni} 
        ${data.usuario.correo} 
        ${data.usuario.perfil.pnombre} 
        ${data.usuario.perfil.papellido}
        ${data.usuario.estatus.nombre}
        `.toLowerCase();
      return userData.includes(q);
    },
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={usuEntidadesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={`Listado de ${usuEntidadesStore.pagination.totalItems} registros`}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {usuEntidadesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6" fontWeight="bold">
            {usuEntidadesStore.activo?.perfiles.length > 0
              ? usuEntidadesStore.activo?.perfiles[0].perfil.nombre
              : 'Sin Asignar'}
          </Typography>
          <Typography variant="h6">
            {usuEntidadesStore.activo?.usuario?.perfil.pnombre}{' '}
            {usuEntidadesStore.activo?.usuario?.perfil.papellido}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoUsuEntidades;
